<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-building_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">法人管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'corporation' }">戻る</router-link>
    </div>
    <div class="container">
      <label>法人凍結 ー </label>
      <label class="label lb-red">注意：この作業はスタッフ二人以上で確認の上で実行してください</label>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）：</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">凍結開始月：</th>
            <td>
              <v-select
                tag="div"
                v-model="frozenMonth"
                placeholder="選択してください"
                class="custom-select mr-sm-2"
                id="inlineFormCustomSelect-2"
                style="width: 180px;"
                :clearable="false"
                :options="frozenMonthJPs"
                :reduce="(option) => option.value"
                label="text"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-0"
                  v-model="allChildFrozenChecked"
                />
                <label class="custom-control-label" for="column-display-check-0">
                  この法人IDに関連するブランド、教場、コース、クラス、先生ID、生徒IDはすべて凍結されることを理解しています。
                </label>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-1"
                  v-model="noStudentChecked"
                />
                <label class="custom-control-label" for="column-display-check-1">
                  この法人IDに関連づけられている生徒IDのうち、継続して利用するものは全て所属法人を変更しました。
                </label>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      <div class="m-5 text-center">
        <button
          type="button"
          class="btn btn-red"
          @click="confirmFrozen"
          :disabled="!frozenMonth || !allChildFrozenChecked || !noStudentChecked"
        >
          凍結実行
        </button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="一覧に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>法人凍結</template>
        <template v-slot:body>法人の凍結、または凍結予約が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { basicCorporationNameIdPresent } from '@/presenters/fields';
import { nextNMonthJPs } from '@/utils/year_helpers';
import { nextNDayJPs } from '@/utils/date_helpers';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    PopUpHolder,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('corporation/fetchCorporation', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  data() {
    return {
      frozenMonth: null,
      allChildFrozenChecked: false,
      noStudentChecked: false,
    };
  },
  computed: {
    currentCorporation() {
      return this.corporation.corporation;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentCorporation);
    },
    frozenMonthJPs() {
      let numberOfMonths = 12;
      let arrayOfMonths = [];
      if (Vue.config.stagingBuild) {
        arrayOfMonths = nextNDayJPs(numberOfMonths);
      } else {
        arrayOfMonths = nextNMonthJPs(numberOfMonths);
      }
      arrayOfMonths.unshift({
        value: 'now',
        text: '今すぐ凍結',
      });
      return arrayOfMonths;
    },
    ...mapState(['corporation']),
  },
  methods: {
    confirmFrozen() {
      this.$logger.debug('Confirm frozen');
      let payload = {
        id: this.currentCorporation.id,
        frozenMonth: this.frozenMonth,
      };
      this.freezeCorporation(payload).then(() => {
        this.$logger.debug('Show success popup');
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'corporation' });
    },
    ...mapActions('corporation', ['freezeCorporation']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
.lb-red {
  color: red;
  margin-left: 5px;
}
.custom-control-label {
  font-weight: normal;
}
</style>
